import api from "./api";

const TOKEN_KEY = "@aplicap-Token";
const DOCUMENT_KEY = "@aplicap-document";
const USERNAME_KEY = "@aplicap-Username";
const KEEP_CONNECT = "@aplicap-keepConnect";

const RESOURCE = "/api/usuarios";

const Auth = {
  isAuthenticated: () => sessionStorage.getItem(TOKEN_KEY) !== null,
  getUser: async () => await api.get(RESOURCE + `/get-user`),
  getToken: () => sessionStorage.getItem(TOKEN_KEY),
  setToken: (token) => {
    sessionStorage.setItem(TOKEN_KEY, token);
  },
  getDocument: () => sessionStorage.getItem(DOCUMENT_KEY),
  setDocument: (document) => {
    sessionStorage.setItem(DOCUMENT_KEY, document);
  },
  unsetDocument: () => {
    sessionStorage.removeItem(DOCUMENT_KEY);
  },
  getUsername: () => sessionStorage.getItem(USERNAME_KEY) || "",
  setUsername: (username) => {
    sessionStorage.setItem(USERNAME_KEY, username);
  },
  getKeepConnect: () => sessionStorage.getItem(KEEP_CONNECT),
  setKeepConnect: () => {
    sessionStorage.setItem(KEEP_CONNECT, true);
  },
  deleteKeepConnect: () => {
    sessionStorage.removeItem(KEEP_CONNECT);
  },
  logout: () => {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(USERNAME_KEY);
  },
};

export default Auth;
